<div
  class="sp-width__full sp-height__full sp-page__with-navbar"
  [ngClass]="getNavbarClass()">
  <app-navbar
    class="sp-hidden__before-lg"
    [current_nav_item]="current_nav_item"
    [navbar_status]="navbar_status"
    (status_change)="onNavbarStatusChange($event)"></app-navbar>

  <div class="sp-position__relative">
    <app-toolbar
      [current_nav_item]="current_nav_item"
      [width_class]="getToolbarWidthClass()"></app-toolbar>

    <div class="sp-page__with-absolute-toolbar sp-grid__gap sp-padding__x2 sp-cluster__grid">
      <h2 class="sp-color__accent">{{ 'SETTINGS.CLUSTER_LABEL' | translate }}</h2>

      <app-cluster-data (refresh)="onRefresh()"></app-cluster-data>
    </div>
  </div>
</div>
